export default __webpack_public_path__ + "static/howto-recruiters3-9d51f7be3adf3ccf6578805333e0ea0a.svg";